'use client'
import { AdminFAQsAPI, FaqStatusChangeAPI } from "@/Utils/APIRequest/Endpoints"
import usePost from "@/Utils/Hooks/usePost"
import { CustomToast } from "@/Utils/CustomToast"
import moment from "moment"
import TableHoc from "@/Utils/HOC/TableHoc"
import FaqModal from "./FaqModal"
import CustomTableHead from "@/Component/Common/Tables/CustomTableHead"
import { TableDeleteSVG, TableEditSVG } from "@/Component/Common/SVGs/CommonSVG"
import ActiveDeactiveStatus from "@/Component/Common/Tables/ActiveDeactiveStatus"
import NoDataTable from "@/Component/Common/Tables/NoData/NoDataTable"
import ConfirmationModal from "@/Component/Common/Modal/ConfirmationModal"

const FaqTable = (props) => {
    const { deleteModal, modal, setDeleteModal, setModal, apiData, activeTab } = props
    const FaqData = apiData?.data?.data

    // API DELETE
    const { isPending: deleteLoader, mutate } = usePost(`${AdminFAQsAPI}/${deleteModal?.id}`, null, (response) => {
        if (response.status == 200 || response.status == 204) {
            CustomToast("success", 'FAQ deleted successfully')
            apiData?.refetch()
            setDeleteModal(null)
        }
    }, 'delete')

    const tableHeadData = {
        head: [
            { title: "Sr No.", sorting: false },
            { title: "Question", apiKey: "questions", sorting: true },
            { title: "FAQ For", apiKey: "faq_for", sorting: true },
            { title: "Created At", apiKey: "created_at", sorting: true },
            { title: "Status", apiKey: "is_active", sorting: true },
            { title: "Action", sorting: false },
        ]
    }

    const callbackFunction = () => {
        mutate()
    }
    return (
        <>
            <table className="w-full text-sm text-left rtl:text-right">
                <CustomTableHead tableHeadData={tableHeadData} params={apiData?.params} setParams={apiData?.setParams} />
                <tbody>
                    {
                        FaqData?.length > 0
                            ?
                            FaqData?.map((faq, index) => (
                                <tr className="border-b border-lightGray last:border-none font-normal hover:bg-lightGray/20 align-middle" key={index}>
                                    <td className="px-5 py-4">
                                        {((apiData?.params.page - 1) * apiData?.params.per_page) + 1 + index}
                                    </td>
                                    <td className="px-5 py-4">
                                        {faq?.questions ?? '-'}
                                    </td>
                                    <td className="px-5 py-4 capitalize">
                                        {faq?.faq_for ?? '-'}
                                    </td>
                                    <td className="px-5 py-4">
                                        {moment.utc(faq?.created_at).local().format('MMM DD, YYYY')}
                                    </td>
                                    <ActiveDeactiveStatus data={faq} apiProps={{ endpoint: `${FaqStatusChangeAPI}/${faq?.id}`, path: null }} refetch={apiData?.refetch} />
                                    <td className="px-5 py-4">
                                        <div className="flex items-center">
                                            <button type='button' className='mr-5' onClick={() => setModal(faq)} title="Edit">
                                                <TableEditSVG />
                                            </button>
                                            <button type='button' onClick={() => setDeleteModal(faq)} title="Delete">
                                                <TableDeleteSVG />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                            : <NoDataTable colSpan={5} />
                    }
                </tbody>
            </table>
            {modal && <FaqModal modal={modal} setModal={setModal} refetch={apiData?.refetch} activeTab={activeTab} />}
            {deleteModal && <ConfirmationModal loader={deleteLoader} modal={deleteModal} args={{ message: "Are you sure? You want to delete this FAQ?" }} setModal={setDeleteModal} callbackFunction={callbackFunction} />}
        </>
    )
}

export default TableHoc(FaqTable)
